import React from "react";

const steps = [
  {
    year: "May 2025 – Present",
    title: "Senior Frontend Developer",
    company: "CodeAegis Private Limited",
    details:
      "Leading frontend development for enterprise and marketing web applications using Next.js, React, Tailwind CSS, JavaScript, and REST APIs. Designed and developed the CodeAegis corporate website and contributed to live projects including SmartCarrots, LBW11, and BNEA. Focused on building scalable, pixel-perfect, responsive, SEO-friendly, and high-performance user interfaces while collaborating closely with designers and backend developers.",
    delay: "300",
  },
  {
    year: "Jun 2022 – May 2025",
    title: "Senior Web Designer / UI Lead",
    company: "iDigital Web",
    details:
      "Led UI/UX design and frontend execution for 20+ admin panels, dashboards, and client projects. Designed role-based interfaces and complex user workflows while working with Core PHP, Laravel, CodeIgniter, HTML, CSS, Bootstrap, and jQuery. Collaborated with backend teams, managed client feedback and design approvals, and mentored a team of designers and developers.",
    delay: "400",
  },
  {
    year: "Jun 2020 – Jun 2022",
    title: "Junior UX / Web Designer",
    company: "Codewraps Pvt. Ltd. & iDigital Web",
    details:
      "Started my professional journey in web and UI design, creating responsive website layouts and frontend interfaces with a strong focus on usability and visual consistency. Converted UI designs into functional, cross-browser web pages using HTML, CSS, Bootstrap, and jQuery, while building frontend screens and admin interfaces for PHP-based client projects.",
    delay: "500",
  },
];

export default function Industries(props) {
  return (
    <section className="industriesSection pt-0 pb-0">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="aboutHeadings text-center">
              <h2>{props.industriesHeading}</h2>

              <h4 className="brandText">
                {props.industriesSubHeading}
              </h4>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-8 text-center">
            <div className="vertical-progress-steps">
              <ul className="steps">
                {steps.map((step, index) => (
                  <li
                    key={index}
                    className="step"
                    data-aos="fade-down"
                    data-aos-easing="ease-out-cubic"
                    data-aos-duration="500"
                    data-aos-delay={step.delay}
                  >
                    <div className="step-marker">
                      <div className="circle"></div>
                    </div>

                    <div className="step-content">
                      <span className="step-year">
                        {step.year}
                      </span>

                      <h3 className="step-title">
                        {step.title}
                      </h3>

                      <div className="step-company">
                        {step.company}
                      </div>

                      <p className="step-details">
                        {step.details}
                      </p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}